<template>
    <BreadCrumb PageTitle="Qwilr Form Integration" />
    <QwilrForm />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import QwilrForm from "../../components/Integrations/QwilrForm.vue";
  
  export default defineComponent({
    name: "QwilrFormPage",
    components: {
      BreadCrumb,
      QwilrForm,
    },
  });
  </script>